import React, { useState } from 'react';
import '../styles/Modals.css';

interface RuleHelpModalProps {
  onClose: () => void;
}

const RuleHelpModal: React.FC<RuleHelpModalProps> = ({ onClose }) => {
  const [activeTab, setActiveTab] = useState<'basics' | 'huxi' | 'actions' | 'patterns'>('basics');

  return (
    <div className="modal-overlay">
      <div className="modal-content rule-help-modal">
        <div className="modal-header">
          <h3>📖 字牌（跑胡子）规则秘籍</h3>
          <button className="modal-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="rule-tabs">
          <button
            className={`rule-tab-btn ${activeTab === 'basics' ? 'active' : ''}`}
            onClick={() => setActiveTab('basics')}
          >
            🎴 牌组构成
          </button>
          <button
            className={`rule-tab-btn ${activeTab === 'huxi' ? 'active' : ''}`}
            onClick={() => setActiveTab('huxi')}
          >
            🔢 胡息表
          </button>
          <button
            className={`rule-tab-btn ${activeTab === 'actions' ? 'active' : ''}`}
            onClick={() => setActiveTab('actions')}
          >
            ⚡ 优先级规则
          </button>
          <button
            className={`rule-tab-btn ${activeTab === 'patterns' ? 'active' : ''}`}
            onClick={() => setActiveTab('patterns')}
          >
            👑 名堂与胡牌
          </button>
        </div>

        <div className="rule-tab-content">
          {activeTab === 'basics' && (
            <div className="rule-section">
              <h4>一、 牌组基本构成 (共 80 张牌)</h4>
              <p>字牌共包含大小两套字，每张各 4 份：</p>
              <ul>
                <li>
                  <strong>小字 (10种)：</strong> 一、<span className="red-text">二</span>、三、四、五、六、<span className="red-text">七</span>、八、九、<span className="red-text">十</span> (各4张，其中二/七/十为红色)。
                </li>
                <li>
                  <strong>大字 (10种)：</strong> <span className="red-text">壹</span>、<span className="red-text">贰</span>、叁、肆、伍、陆、<span className="red-text">柒</span>、捌、玖、<span className="red-text">拾</span> (各4张，其中壹/贰/柒/拾为红色)。
                </li>
              </ul>
              <div className="rule-callout">
                💡 <strong>发牌规则：</strong> 庄家开局拿 21 张，闲家各拿 20 张。庄家首轮直接打出一张牌，之后每位玩家轮流先摸牌再出牌。
              </div>
            </div>
          )}

          {activeTab === 'huxi' && (
            <div className="rule-section">
              <h4>二、 核心胡息对照表</h4>
              <p>起胡门槛通常为 <strong>15 胡息</strong>。只有面子胡息总和达到标准方可胡牌：</p>
              <table className="huxi-rule-table">
                <thead>
                  <tr>
                    <th>成牌类型</th>
                    <th>小字胡息</th>
                    <th>大字胡息</th>
                    <th>说明</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>提 / 跑</strong> (4张相同)</td>
                    <td className="gold-text">9 胡</td>
                    <td className="gold-text">12 胡</td>
                    <td>起手4张或场上出现第4张</td>
                  </tr>
                  <tr>
                    <td><strong>坎 / 扫</strong> (3张相同)</td>
                    <td>3 胡</td>
                    <td>6 胡</td>
                    <td>手中暗坎或自摸3张</td>
                  </tr>
                  <tr>
                    <td><strong>碰</strong> (3张相同)</td>
                    <td>1 胡</td>
                    <td>3 胡</td>
                    <td>别人打出后组合</td>
                  </tr>
                  <tr>
                    <td><strong>壹贰叁 / 一二三</strong></td>
                    <td>3 胡</td>
                    <td>6 胡</td>
                    <td>固定首顺</td>
                  </tr>
                  <tr>
                    <td><strong>贰柒拾 / 二七十</strong></td>
                    <td>3 胡</td>
                    <td>6 胡</td>
                    <td>红牌特殊顺</td>
                  </tr>
                  <tr>
                    <td><strong>普通顺子 / 绞牌</strong></td>
                    <td>0 胡</td>
                    <td>0 胡</td>
                    <td>如 4-5-6 或 壹壹一 (仅用于凑门子)</td>
                  </tr>
                  <tr>
                    <td><strong>将牌 (对子)</strong></td>
                    <td>0 胡</td>
                    <td>0 胡</td>
                    <td>胡牌必须包含一对将牌</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {activeTab === 'actions' && (
            <div className="rule-section">
              <h4>三、 绝对动作优先级 (防止抢牌纠纷)</h4>
              <p>当一张牌被摸出或打入判定区时，系统按以下严格优先级判定：</p>
              <ol className="priority-list">
                <li>
                  <span className="p-badge p1">Priority 1</span> <strong>提 / 跑 / 扫：</strong> 强制性动作，触发时自动执行并亮牌，摸牌者提牌需补摸一张。
                </li>
                <li>
                  <span className="p-badge p2">Priority 2</span> <strong>胡牌：</strong> 满足 15 胡息即可抢胡。多名玩家同时可胡时，按座次顺位（摸牌者 ➜ 下家 ➜ 闲家）先到先得。
                </li>
                <li>
                  <span className="p-badge p3">Priority 3</span> <strong>碰：</strong> 手中有两张相同时可碰为明刻。
                </li>
                <li>
                  <span className="p-badge p4">Priority 4</span> <strong>吃：</strong> 仅限摸牌者本人或其下家可吃。吃牌后须从手中打出一张牌。
                </li>
              </ol>
            </div>
          )}

          {activeTab === 'patterns' && (
            <div className="rule-section">
              <h4>四、 经典名堂加番</h4>
              <ul>
                <li><strong>红胡：</strong> 赢家整副牌中红字数量 ≥ 10 张（番数翻倍）。</li>
                <li><strong>大红胡：</strong> 整副牌中红字数量 ≥ 13 张（番数翻四倍）。</li>
                <li><strong>点胡：</strong> 整副牌中仅有 1 张红字（番数翻倍）。</li>
                <li><strong>黑胡 / 乌胡：</strong> 整副牌中全为黑字，无一张红字（大满贯）。</li>
                <li><strong>自摸：</strong> 自己摸到胡牌张（+1 番）。</li>
                <li><strong>碰碰胡 / 坎坎胡：</strong> 整副牌全部由三张/四张刻子组成，无任何顺子。</li>
              </ul>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-primary" onClick={onClose}>
            我明白了，返回牌局
          </button>
        </div>
      </div>
    </div>
  );
};

export default RuleHelpModal;